/**
 * Конфигурации для различных типов графиков
 */

// Базовые опции для всех графиков
export const baseOptions = {
    responsive: true,
    maintainAspectRatio: false,
    plugins: {
        legend: {
            position: "top",
            labels: {
                font: {
                    family: "'Inter', sans-serif",
                    size: 12,
                },
                usePointStyle: true,
                padding: 15,
            },
        },
        tooltip: {
            backgroundColor: "rgba(30, 30, 30, 0.8)",
            titleFont: {
                family: "'Inter', sans-serif",
                size: 13,
            },
            bodyFont: {
                family: "'Inter', sans-serif",
                size: 12,
            },
            padding: 10,
            cornerRadius: 4,
            usePointStyle: true,
        },
    },
};

// Опции для столбчатых диаграмм (Bar)
export const barChartOptions = {
    ...baseOptions,
    scales: {
        x: {
            grid: {
                display: false,
                color: "#3E3E42", // не ошибка, но тут color не нужен, потому что display: false (сетка вообще не рисуется)
            },
            ticks: {
                color: "#E5E7EB", // цвет подписей на оси
                font: {
                    family: "'Inter', sans-serif",
                    size: 11,
                },
            },
        },
        y: {
            beginAtZero: true,
            min: 0, // Я добавлю min: 0 для надёжности, чтобы график точно с нуля начинался
            grid: {
                color: "#3E3E42", // цвет линий сетки
            },
            ticks: {
                precision: 0, // целые числа
                stepSize: 1, // шаг между линиями по Y = 1
                color: "#E5E7EB",
                font: {
                    family: "'Inter', sans-serif",
                    size: 11,
                },
            },
        },
    },
};

// Опции для линейных графиков (Line)
export const lineChartOptions = {
    ...baseOptions,
    scales: {
        x: {
            type: "time",
            time: {
                unit: "day",
                tooltipFormat: "dd.MM.yyyy",
                displayFormats: {
                    day: "dd.MM",
                },
            },
            title: {
                display: true,
                text: "Дата",
            },
            grid: {
                display: false,
            },
        },
        y: {
            beginAtZero: true,
            grid: {
                color: "rgba(243, 244, 246, 1)",
            },
            ticks: {
                precision: 0,
            },
        },
    },
    elements: {
        line: {
            tension: 0.3,
        },
        point: {
            radius: 2,
            hoverRadius: 4,
        },
    },
};

export const heatmapOptions = {
    ...baseOptions,
    parsing: {
        xAxisKey: "x",
        yAxisKey: "y",
    },
    scales: {
        x: {
            type: "time",
            time: {
                unit: "day",
                round: "day",
                tooltipFormat: "dd.MM",
                displayFormats: {
                    day: "dd.MM",
                },
            },
            ticks: {
                source: "data",
                autoSkip: false,
                callback: function (value, index, ticks) {
                    return this.getLabelForValue(value);
                },
            },
            title: {
                display: true,
                text: "Дата",
            },
            grid: {
                display: false,
            },
        },
        y: {
            type: "category",
            title: {
                display: true,
                text: "Сотрудники",
            },
            grid: {
                display: false,
            },
            ticks: {
                autoSkip: false,
            },
        },
    },
    plugins: {
        ...baseOptions.plugins,
        tooltip: {
            ...baseOptions.plugins.tooltip,
            callbacks: {
                label: (context) => {
                    const { raw } = context;
                    if (!raw) return "Нет данных";

                    const statuses = [];
                    if (raw.delay > 0)
                        statuses.push(`Опоздание: ${raw.delay} мин.`);
                    if (raw.overtime > 0)
                        statuses.push(`Переработка: ${raw.overtime} мин.`);
                    if (raw.earlyExit > 0)
                        statuses.push(`Ранний уход: ${raw.earlyExit} мин.`);
                    if (raw.missed) statuses.push("Пропуск");

                    return statuses.length
                        ? statuses.join(", ")
                        : "Без нарушений";
                },
            },
        },
    },
};
